import { useSite } from "../context/SiteContext";

function Stars() {
  return (
    <div className="flex gap-0.5 text-gold" aria-label="5 out of 5 stars">
      {[0, 1, 2, 3, 4].map((i) => (
        <span key={i}>★</span>
      ))}
    </div>
  );
}

export default function Testimonials() {
  const { settings } = useSite();
  const t = settings?.testimonials;
  if (!t?.enabled) return null;

  const items = (t.items || [])
    .filter((x) => !x.is_sample)  // Phase 4: samples hidden from public
    .slice()
    .sort((a, b) => (b.featured ? 1 : 0) - (a.featured ? 1 : 0));

  if (items.length === 0) return null;

  return (
    <section id="testimonials" className="section" data-testid="testimonials-section">
      <div className="container-x px-5 md:px-8">
        <div className="max-w-2xl mx-auto text-center mb-12">
          <div className="eyebrow justify-center mx-auto mb-4">Reviews</div>
          <h2 className="font-display text-4xl md:text-6xl text-gold leading-tight">
            What clients say.
          </h2>
          <p className="text-ivory-dim mt-3 italic text-sm md:text-base">
            Every review is real. Names are always kept private.
          </p>
        </div>

        <div
          className="grid md:grid-cols-3 gap-5 md:gap-6"
          data-testid="testimonials-grid"
        >
          {items.map((it, i) => (
            <figure
              key={it.id || i}
              className="card-luxe p-6 md:p-7 flex flex-col justify-between h-full"
              data-testid={`testimonial-${i}`}
            >
              <div>
                <Stars />
                <blockquote className="mt-4 font-serif italic text-lg md:text-xl text-ivory leading-relaxed">
                  <span className="text-gold text-2xl leading-none mr-1">“</span>
                  {it.quote}
                  <span className="text-gold text-2xl leading-none ml-1">”</span>
                </blockquote>
              </div>
              <figcaption className="mt-5 pt-5 border-t border-[rgba(201,169,97,0.14)] text-sm text-gold-2 tracking-wider">
                — {it.attribution}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
